
import * as defaultImport from "@splunk/dashboard-context";
export * from "@splunk/dashboard-context";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
